export default [
  { id: 'users', labelStringId: 'users', path: '/users', icon: 'fa-thin fa-users' },
  { id: 'invitedUsers', labelStringId: 'invitedUsers', path: '/invited-users', icon: 'fa-thin fa-user-plus' },
  { id: 'setup', labelStringId: 'setup', path: '/setup', icon: 'fa-thin fa-gear' },
];
